import {
  ISoccerMatchPenaltyShotEvent,
  ISoccerMatchPenaltyShotEventWithCount,
} from "../../../../types";

type PenaltyShotEventIconProps = {
  event: ISoccerMatchPenaltyShotEvent | ISoccerMatchPenaltyShotEventWithCount;
  iconSize?: number;
  showCount?: boolean;
  showTime?: boolean;
  wrapperClassName?: string;
  countClassName?: string;
  timeClassName?: string;
};

export function GlobalPenaltyShot({
  event,
  iconSize = 16,
  showCount = false,
  showTime = false,
  wrapperClassName = "",
  countClassName = "event-count",
  timeClassName = "time-match-key-event",
}: PenaltyShotEventIconProps) {
  if (!event.outcome) return null;

  const imgSrc =
    event.outcome === "scored"
      ? "/images/match-events/penalty-goal-bg.svg"
      : "/images/match-events/missed-penalty-bg.svg";

  return (
    <div className={wrapperClassName}>
      {showCount && "count" in event && event.count > 1 && (
        <span className={countClassName}>{event.count}</span>
      )}
      <img
        src={imgSrc}
        height={iconSize}
        width={iconSize}
        alt="penalty shot"
        className="goal-event"
      />
      {showTime && <span className={timeClassName}>{`${event.timeMin}'`}</span>}
    </div>
  );
}
